import React, { useState } from 'react';
import { Modal, Alert } from 'antd';

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
}

const SlotRefundModal: React.FC<Props> = ({ open, onClose, onSubmit }) => {
  const [submitting, setSubmitting] = useState(false);

  return (
    <Modal
      open={open}
      title="환불 확인"
      okText="환불"
      okButtonProps={{ danger: true }}
      confirmLoading={submitting}
      onCancel={() => { if (!submitting) onClose(); }}
      onOk={async () => {
        if (submitting) return;
        setSubmitting(true);
        try {
          await onSubmit();
          onClose();
        } finally {
          setSubmitting(false);
        }
      }}
    >
      <Alert
        message="선택한 슬롯을 모두 환불하시겠습니까?"
        description="환불 시 종료일이 오늘로 변경되고 남은일수는 0으로 표시됩니다."
        type="warning"
        showIcon
      />
    </Modal>
  );
};

export default SlotRefundModal;
